<template>
<div class="chapter">
<div class="inner_page">
<p class="noind" id="epigraph">‘The night sky is a celestial river; every man must find the one true star that will guide him along it.’</p>
<p class="right">From ‘A Meeting at the Summer Palace’ by Yi Ping</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4epigraph.vue?14b74b74